import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          本周最受欢迎的影片排行，影迷都在看这些
        </p>
        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-50 transition-colors`}
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                {item.rank <= 3 ? (
                  <span
                    className={`text-lg font-bold ${
                      item.rank === 1
                        ? 'text-accent-500'
                        : item.rank === 2
                          ? 'text-foreground-400'
                          : 'text-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-400">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-foreground-800 truncate">{item.title}</p>
                <p className="text-xs text-foreground-400">{item.category}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-bold text-primary-500">{item.hot}</span>
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}